"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalDisclaimerModalShortPathCMS = void 0;
var LegalDisclaimerModalShortPathCMS = /** @class */ (function () {
    function LegalDisclaimerModalShortPathCMS() {
        this.legalText = "We'll charge all monthly payments to your payment method at 7 p.m.\n    ET on the dates shown below. Taxes and surcharges are extra.<br>\n";
        this.shortLegalLinkLabel = 'See DIRECTV NOW Payment Schedule';
    }
    return LegalDisclaimerModalShortPathCMS;
}());
exports.LegalDisclaimerModalShortPathCMS = LegalDisclaimerModalShortPathCMS;
//# sourceMappingURL=LegalDisclaimerShortPath.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/PaymentDetailsPanel/PaymentScheduleModal/LegalDisclaimerShortPath.cms.js
// module id = 2031
// module chunks = 8